import { Routes, Route, Navigate } from 'react-router-dom';
import { AdminAuthProvider, useAdminAuth } from './contexts/AdminAuthContext';
import AdminLayout from './components/AdminLayout';
import Login from './pages/Login';
import ChiPhi from './pages/ChiPhi';
import PhiCoDinh from './pages/PhiCoDinh';
import TuVan from './pages/TuVan';
import Ebook from './pages/Ebook';
import Settings from './pages/Settings';
import FooterAdmin from './pages/Footer';
import DoiMatKhau from './pages/DoiMatKhau';
import './admin.css';

function RequireAuth({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAdminAuth();
  if (loading) {
    return <div className="center-screen muted">Đang tải…</div>;
  }
  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }
  return <>{children}</>;
}

export default function AdminApp() {
  return (
    <AdminAuthProvider>
      <div className="admin-shell">
        <Routes>
          <Route path="login" element={<Login />} />
          <Route
            element={
              <RequireAuth>
                <AdminLayout />
              </RequireAuth>
            }
          >
            <Route index element={<Navigate to="chi-phi" replace />} />
            <Route path="chi-phi" element={<ChiPhi />} />
            <Route path="phi-co-dinh" element={<PhiCoDinh />} />
            <Route path="tu-van" element={<TuVan />} />
            <Route path="ebook" element={<Ebook />} />
            <Route path="settings" element={<Settings />} />
            <Route path="footer" element={<FooterAdmin />} />
            <Route path="doi-mat-khau" element={<DoiMatKhau />} />
          </Route>
          <Route path="*" element={<Navigate to="chi-phi" replace />} />
        </Routes>
      </div>
    </AdminAuthProvider>
  );
}
